import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// P0: the caching PWA service worker froze always-open WebView clients on stale JS/CSS.
// We NO LONGER register a caching SW. unregister() removes any SW still registered on a
// client running this (new) bundle; already-frozen clients are healed by the self-destruct
// SW at /service-worker.js (their old SW updates to it, which purges caches + unregisters
// + reloads). After that, no SW is registered and the app always fetches the live bundle.
serviceWorkerRegistration.unregister();
